/* eslint-disable */
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Box, Stack, TextField, Typography, Button, Table, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { HomeOutlined } from '@ant-design/icons';
import 'react-toastify/dist/ReactToastify.css';

import GlobalBackButton from 'views/utilities/BackButtonGlobal';
import BcConvertModal from 'views/Components/BcConvertModal';
import CommonTable from 'views/Components/CommonTable';

import { useTransactionLimit, useBeneficiaryDetails, useCheckIsMerchantOrBc, useDeleteBeneficiary } from './DmtHooks/useBeneficiaryHooks';
import { DeleteModal } from './DmtReusableComponents/DeleteModal';
import { getBeneficiaryColumns } from './constants';

export default function BeneficiaryList() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const location = useLocation();

    // State
    const [params, setParams] = useState({ search: '', page: 1, limit: 10 });
    const [modalState, setModalState] = useState({ openDeleteDialog: false, openBcModal: false });
    const [selectedRow, setSelectedRow] = useState(null);

    const data = location?.state?.item || location?.state?.data;
    const customerId = location?.state?.item?.id || location?.state?.customerId || '';
    const senderno = data?.mobileNumber || location?.state?.search || localStorage.getItem('sendernumber');
    const dmtType = 1;

    // --- TanStack Query Hooks ---
    const { data: maxLimit } = useTransactionLimit(senderno, dmtType);
    const {
        benefDetails,
        totalCount,
        isLoading: benefListLoading
    } = useBeneficiaryDetails(customerId, params.page, params.limit, params.search);
    const { data: merchantCheckData } = useCheckIsMerchantOrBc();
    const { mutate: deleteBeneficiary } = useDeleteBeneficiary();

    const isBcConvertPending = merchantCheckData?.isBcConvertPending || false;

    useEffect(() => {
        if (merchantCheckData?.shouldOpenModal) {
            setModalState((prev) => ({ ...prev, openBcModal: true }));
        }
    }, [merchantCheckData?.shouldOpenModal]);

    const handleChange = (e) => setParams((prev) => ({ ...prev, search: e.target.value, page: 1 }));
    const handleBcModalClose = () => setModalState((prev) => ({ ...prev, openBcModal: false }));

    const handleTransferClick = (row) => {
        navigate('/moneyTransfer1/moneyTransfer', {
            state: {
                data,
                row,
                filteredData: location?.state?.filteredData,
                index: location?.state?.index,
                indexBenef: row.id,
                senderno,
                customerId
            }
        });
    };

    const NavigateBtn = ({ btnName, navigatePath, navigateState }) => (
        <Button color="primary" variant="contained" disableElevation sx={{ m: 2 }} onClick={() => navigate(navigatePath, navigateState)}>
            {btnName}
        </Button>
    );

    const columns = getBeneficiaryColumns({ params, isMobile, handleTransferClick, setSelectedRow, setModalState });

    return (
        <>
            <div>
                <Box
                    sx={{
                        width: '100%',
                        height: 'auto',
                        backgroundColor: '#fff',
                        m: 0,
                        borderRadius: 2,
                        marginBottom: 2,
                        padding: '20px 10px',
                        '@media screen and (min-width: 600px)': { padding: 2 }
                    }}
                >
                    <Typography variant="h3">
                        <GlobalBackButton />
                        Domestic Money Transfer
                    </Typography>

                    <Box sx={{ marginTop: '10px' }}>
                        <Link to="/merchant-home" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <HomeOutlined />
                        </Link>
                        <Typography component="span" style={{ margin: '0 10px' }}>
                            &gt;
                        </Typography>
                        <Link to="/moneyTransfer1/viewCustomers" state={{ data }} style={{ textDecoration: 'none', color: 'inherit' }}>
                            <Typography component="span">View Customer</Typography>
                        </Link>
                    </Box>
                </Box>

                <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name : {data?.customerName}</TableCell>
                                {!isMobile && (
                                    <TableCell align="right">
                                        KYC : {data?.ekycStatus === false ? 'KYC Not Applied' : 'KYC Applied'}
                                    </TableCell>
                                )}
                                {!isMobile && <TableCell align="right">Mobile :{senderno}</TableCell>}
                                {!isMobile && <TableCell align="right">MONTHLY LIMIT :{maxLimit ? maxLimit : '0'}</TableCell>}
                            </TableRow>
                        </TableHead>
                    </Table>
                </TableContainer>

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <NavigateBtn
                        btnName="Add Beneficiary"
                        navigatePath="/moneyTransfer1/createBeneficiary"
                        navigateState={{ state: { customerId, data, senderno } }}
                    />
                    <NavigateBtn
                        btnName="List All Beneficiaries"
                        navigatePath="/moneyTransfer1/listAllBeneficiary"
                        navigateState={{ state: { data, senderno } }}
                    />
                    <NavigateBtn
                        btnName="List moneyTransfer"
                        navigatePath="/moneyTransfer1/listMoneyTransfer"
                        navigateState={{ state: { data, senderno } }}
                    />

                    <Stack direction="row" spacing={2} sx={{ mb: 1 }}>
                        <TextField
                            label="Search with Beneficiary Name"
                            name="search"
                            value={params.search}
                            onChange={handleChange}
                            variant="outlined"
                        />
                    </Stack>
                </div>

                <CommonTable
                    columns={columns}
                    data={benefDetails}
                    isLoading={benefListLoading}
                    totalCount={totalCount}
                    page={params.page}
                    limit={params.limit}
                    onPageChange={(e, value) => setParams((prev) => ({ ...prev, page: value }))}
                />
            </div>

            <DeleteModal
                deleteWord="Beneficiary"
                modalState={modalState.openDeleteDialog}
                setModalState={(val) => setModalState((prev) => ({ ...prev, openDeleteDialog: val }))}
                selectedRow={selectedRow}
                deleteBeneficiary={deleteBeneficiary}
            />
            {modalState.openBcModal && (
                <BcConvertModal
                    isOpen={modalState.openBcModal}
                    handleclose={handleBcModalClose}
                    isPending={isBcConvertPending}
                    serviceName={'dmt'}
                    isESigned={merchantCheckData?.isESigned}
                />
            )}
        </>
    );
}
